$(document).ready(function (e) {
    // SP drawer menu
    $("#js-nav-drawer-open").on("click", function () {
        $("#js-nav-drawer").addClass("active");
        $("#js-nav-drawer-overlay").addClass("active");
        $(".nav-drawer__container").show();
        scrollPosition = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollPosition });
    });
    $("#js-nav-drawer-close").on("click", function () {
        $("#js-nav-drawer").removeClass("active");
        $("#js-nav-drawer-overlay").removeClass("active");
        $("body").removeClass("fixed").css({ top: 0 });
        window.scrollTo(0, scrollPosition);
    });

    // FIX Footer Control
    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 50) {
            $("#js-nav-fixfooter__container").slideDown(100);
            $(".js-nav-fixfooter__button-memo").stop().animate({ marginRight: "86px" }, 100);
            $("#js-nav-pagetop").stop().animate({ marginRight: "60px" }, 100);
        } else {
            $("#js-nav-fixfooter__container").slideUp(100);
            $(".js-nav-fixfooter__button-memo").stop().animate({ marginRight: "0" }, 100);
            $("#js-nav-pagetop").stop().animate({ marginRight: "0" }, 100);
        }
    });

    $(document).on("click", function (e) {
        // 並び替えメニュー表示・非表示
        if (!$(e.target).closest("#js-sort-menu").length) {
            $("#js-sort-menu").next().fadeOut();
        } else {
            $("#js-sort-menu").next().fadeToggle();
        }

        // 絞り込みメニュー表示・非表示
        if (!$(e.target).closest("#js-filter-menu").length) {
            $("#js-filter-menu").next().fadeOut();
        } else {
            $("#js-filter-menu").next().fadeToggle();
        }
    });

    // Smooth Scroll
    const headerHeight = $("#js-nav-header").outerHeight();
    // link from : other page xxx.html
    const urlHash = location.hash;
    if (urlHash) {
        $("body,html").stop().scrollTop(0);
        if ($(".nursery-info__pic-slider").length > 0) {
            $(".nursery-info__pic-slider").on("init", function (event, slick, direction) {
                const target = $(urlHash);
                let position = target.offset().top - headerHeight;
                if (urlHash === "#gmap") {
                    position = position + headerHeight;
                }
                $("body,html").stop().animate({ scrollTop: position }, 500);
            });
        } else {
            setTimeout(function () {
                const target = $(urlHash);
                let position = target.offset().top - headerHeight;
                if (urlHash === "#gmap") {
                    position = position + headerHeight;
                }
                $("body,html").stop().animate({ scrollTop: position }, 500);
            }, 100);
        }
    }
    // link from : same page #id
    $('a[href^="\\/#"]').click(function () {
        const href = $(this).attr("href");
        const target = $(href.replace(/\//g, ""));
        const position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
    });
    // page-top : #
    $('a[href^="#"],area').click(function () {
        const href = $(this).attr("href");
        const target = $(href === "#" || href === "" ? "html" : href);
        const position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, 500);
    });

    //Page Effect
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("edge") !== -1) {
        scroll_effect();
    }
    $(window).on("load scroll", function () {
        scroll_effect();
    });
    function scroll_effect() {
        $(".effect-fade").each(function () {
            const elemPos = $(this).offset().top;
            const scroll = $(window).scrollTop();
            const windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 100) {
                $(this).addClass("effect-scroll");
            }
        });
    }

    $(".nav-drawer__link--has-2nd-menu").on("click", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("open");
    });

    // ボタンを有効にする。
    modalWindow.enableButton();

    $(".form__password-eye").on("click", function () {
        $(this).toggleClass("fa-eye fa-eye-slash");
        const input = $(this).prev("input");
        if (input.attr("type") === "text") {
            input.attr("type", "password");
        } else {
            input.attr("type", "text");
        }
    });
});

/**
 * 基本的な関数たち
 */
const modalWindow = {
    // モーダル表示
    showModal: function (obj, redirectParams, showParentVoicePostLinkForGuest = false) {
        const win_w = $(window).width();

        if (
            obj === "#js-modal-feature" ||
            obj === "#js-modal-contact" ||
            obj === "#js-modal-condition" ||
            obj === "#js-modal-memo" ||
            obj === "#js-modal-profile" ||
            obj === "#js-modal-favorite"
        ) {
            if (win_w <= 600) {
                $(obj).addClass("active");
                scrollPosition = $(window).scrollTop();
                $("body").addClass("fixed").css({ top: -scrollPosition });
                $(obj).find(".modal__overlay").data("modal-id", obj);

                return false;
            }
        }

        $(obj).fadeIn();
        $(obj).addClass("active");
        $(obj).find(".modal__overlay").data("modal-id", obj);
        scrollPosition = $(window).scrollTop();
        $("body").addClass("fixed").css({ top: -scrollPosition });

        // NOTE: リダイレクト用のパラメータを仕込んでいる
        if (redirectParams) {
            $.each($(obj).find("a"), function (index, elm) {
                try {
                    const newUrl = new URL(elm.href);
                    newUrl.searchParams.has("redirect")
                        ? newUrl.searchParams.set("redirect", redirectParams.redirect)
                        : newUrl.searchParams.append("redirect", redirectParams.redirect);
                    newUrl.searchParams.has("nursery_id")
                        ? newUrl.searchParams.set("nursery_id", redirectParams.nursery_id)
                        : newUrl.searchParams.append("nursery_id", redirectParams.nursery_id);
                    if (redirectParams.kind) {
                        newUrl.searchParams.has("kind")
                            ? newUrl.searchParams.set("kind", redirectParams.kind)
                            : newUrl.searchParams.append("kind", redirectParams.kind);
                    }
                    elm.href = newUrl.toString();
                } catch {} // eslint-disable-line no-empty
            });
        } else {
            $.each($(obj).find("a"), function (index, elm) {
                try {
                    const newUrl = new URL(elm.href);

                    newUrl.searchParams.delete("redirect");
                    newUrl.searchParams.delete("nursery_id");
                    newUrl.searchParams.delete("kind");

                    elm.href = newUrl.toString();
                } catch {} // eslint-disable-line no-empty
            });
        }

        // 口コミ投稿の場合
        if (showParentVoicePostLinkForGuest) {
            const htmlToAdd = `
                <dl class="modal__regist-guide-parent-voice-post-link-for-guest js-guest-parent-voice-post-link" >
                    <dt class="modal__regist-guide-txt">会員登録せずに<br class="sp-only">口コミを投稿する</dt>
                    <dd class="form__form-button-area">
                        <a class="button-general-2nd button-general-2nd--full"
                            href="https://docs.google.com/forms/d/e/1FAIpQLSeQFw9Lr9txD_Rvj62CWHIBDIv5YZg_4Bb1ReTN__6aqmi0tQ/viewform?usp=sf_link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >口コミ投稿フォームへ</a>
                    </dd>
                </dl>
            `;
            $("div.modal__container").append(htmlToAdd);
        }
        return false;
    },
    // モーダル非表示
    hideModal: function (targetObject) {
        const obj = $(targetObject).find(".modal__overlay").data("modal-id");
        const win_w = $(window).width();
        if (
            obj === "#js-modal-feature" ||
            obj === "#js-modal-contact" ||
            obj === "#js-modal-condition" ||
            obj === "#js-modal-memo" ||
            obj === "#js-modal-profile" ||
            obj === "#js-modal-favorite"
        ) {
            if (win_w <= 600) {
                $(obj).removeClass("active");
                $("body").removeClass("fixed").css({ top: 0 });
                window.scrollTo(0, scrollPosition);
                return false;
            }
        }
        $(obj).fadeOut();
        $(obj).children($(".modal__overlay")).removeClass("active");
        $("body").removeClass("fixed").css({ top: 0 });
        window.scrollTo(0, scrollPosition);

        $("div.modal__container .js-guest-parent-voice-post-link").remove();

        return false;
    },
    enableButton: function () {
        // 表示
        $(".js-modal-show").unbind();
        $(".js-modal-show").click(function () {
            const target = $(this).data("target");

            // ボタン押してはいけないクラスが設定されていたら無視
            if ($(this).hasClass("button-general--disabled")) {
                return false;
            }

            modalWindow.showModal(target);
        });

        //非表示
        $(".js-modal-hide, .modal__overlay").unbind();
        $(".js-modal-hide").click(function () {
            modalWindow.hideModal($(this).parents(".modal"));
        });

        $(".modal__overlay").click(function () {
            modalWindow.hideModal($(this).parent());
        });
    }
};

window.modalWindow = modalWindow;
